export default __webpack_public_path__ + "static/media/activeMarker.69de0cb4.svg";